module.exports = __webpack_public_path__ + "static/media/gps2.49f0e2a2.svg";